import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SoggettoPratica } from "../../../common/models/tipologiche/soggetto-pratica";
import { HelpersService } from "../../../core/services/helpers.service";
import { MetadataExt } from "src/app/common/models/metadati/metadata";
import { ProtocolMetadata } from "src/app/common/protocol/models/protocol";
import { TipoTipologiaGenericoConsulenza } from "src/app/common/models/tipologiche/tipo-tipologia-generico-consulenza";

@Component({
  selector: "app-form-gestione-amministrativa",
  templateUrl: "./form-gestione-amministrativa.component.html",
  styleUrls: ["./form-gestione-amministrativa.component.css"],
})
export class FormGestioneAmministrativaComponent implements OnInit, OnChanges {
  datiGeneraliForm: FormGroup;
  soggettiOptions: SoggettoPratica[] = [];
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;
  tipologiaGenericoConsulenzaOptions:TipoTipologiaGenericoConsulenza[]=[];
  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  // @Output() tipoRichiedenteChanged = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(
    private campiForm: FormBuilder,
    private helpers: HelpersService
  ) {}

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      // oggetto: [init ? null : this.request.fascicolo.oggetto],
      // societa: [init ? null : this.request.fascicolo.societa, Validators.required],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      richiesta: [init ? null : this.request.fascicolo.richiesta],
      note: [init ? null : this.request.fascicolo.note],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
      tipologiaGenericoConsulenza:[init ? null : this.request.fascicolo.tipologiaGenericoConsulenza]
    });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  populateSelect() {
    // if (this.soggettiOptions.length === 0) {
    //   this.helpers
    //     .getSoggetti()
    //     .subscribe((response) => (this.soggettiOptions = response));
    // }
    if (this.tipologiaGenericoConsulenzaOptions.length === 0) {
      this.helpers.getTipologiaGenericoConsulenza().subscribe(response => this.tipologiaGenericoConsulenzaOptions = response);
    }
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }

  save() {
    this.saveForm.emit();
  }
}
